// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__lato_a88817', '__lato_Fallback_a88817'"},"className":"__className_a88817","variable":"__variable_a88817"};